import { API_BASE_URL } from '../config/api.config';

/** Resolve relative upload paths to absolute URLs for previews. */
export const resolvePropertyMediaUrl = (url) => {
  if (!url || typeof url !== 'string') return '';
  const trimmed = url.trim();
  if (!trimmed) return '';
  if (trimmed.startsWith('blob:') || trimmed.startsWith('data:')) return trimmed;
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) return trimmed;

  const base = API_BASE_URL.replace(/\/api\/?$/, '');
  if (trimmed.startsWith('/')) return `${base}${trimmed}`;
  if (trimmed.startsWith('backend/uploads/')) {
    return `${base}/${trimmed.replace(/^backend\//, '')}`;
  }
  if (trimmed.startsWith('/backend/uploads/')) {
    return `${base}${trimmed.replace(/^\/backend/, '')}`;
  }
  if (trimmed.startsWith('uploads/')) return `${base}/${trimmed}`;
  if (trimmed.startsWith('properties/')) return `${base}/uploads/${trimmed}`;
  return `${base}/uploads/${trimmed}`;
};

export const resolvePropertyImageUrls = (images) => {
  if (!Array.isArray(images)) return [];
  return images.map(resolvePropertyMediaUrl).filter(Boolean);
};

export const buildVideoFromUrl = (videoUrl) => {
  const url = resolvePropertyMediaUrl(videoUrl);
  if (!url) return null;
  const name = decodeURIComponent(url.split('/').pop()?.split('?')[0] || '') || 'Property video';
  return { url, name, size: 0, isExisting: true };
};

export const buildBrochureFromUrl = (brochureUrl) => {
  const url = resolvePropertyMediaUrl(brochureUrl);
  if (!url) return null;
  const name = decodeURIComponent(url.split('/').pop()?.split('?')[0] || '') || 'Brochure.pdf';
  return { url, name, size: 0, isExisting: true };
};

export const createExistingImageValidationStatus = (images = []) =>
  resolvePropertyImageUrls(images).map((imageUrl) => ({
    file: null,
    preview: imageUrl,
    status: 'approved',
    errorMessage: '',
    imageId: null,
    imageUrl,
  }));

/** Map API/listing fields into form-friendly media for edit mode. */
export const hydratePropertyFormMedia = (initialData) => {
  if (!initialData) {
    return {
      images: [],
      video: null,
      brochure: null,
      videoUrl: '',
      brochureUrl: '',
    };
  }

  const images = resolvePropertyImageUrls(initialData.images);
  const videoUrlRaw = initialData.videoUrl || initialData.video_url || '';
  const brochureUrlRaw = initialData.brochureUrl || initialData.brochure_url || '';
  const videoUrl = resolvePropertyMediaUrl(videoUrlRaw) || videoUrlRaw;
  const brochureUrl = resolvePropertyMediaUrl(brochureUrlRaw) || brochureUrlRaw;

  return {
    images,
    video: buildVideoFromUrl(videoUrlRaw),
    brochure: buildBrochureFromUrl(brochureUrlRaw),
    videoUrl,
    brochureUrl,
  };
};

export const isBlobUrl = (url) => typeof url === 'string' && url.startsWith('blob:');
